import React, { useEffect } from 'react'
import { api } from '../api/client'

/**
 * When user is logged in, fetches /me/branding and applies palette as CSS variables on :root.
 * Fallbacks keep dark mode intact when no branding or no hex colors are set.
 */
export default function BrandingTheme() {
  useEffect(() => {
    let mounted = true
    api.get('/me/branding')
      .then((r) => {
        if (!mounted || !r?.data) return
        const d = r.data
        const root = document.documentElement
        const set = (name, value) => {
          if (value && /^#[0-9A-Fa-f]{3,6}$/.test(value)) {
            root.style.setProperty(name, value)
          } else {
            root.style.removeProperty(name)
          }
        }
        set('--brand-primary', d.palette_primary)
        set('--brand-accent', d.palette_accent)
        set('--brand-background', d.palette_background)
        set('--brand-text', d.palette_text)
      })
      .catch(() => {})
    return () => {
      mounted = false
      const root = document.documentElement
      root.style.removeProperty('--brand-primary')
      root.style.removeProperty('--brand-accent')
      root.style.removeProperty('--brand-background')
      root.style.removeProperty('--brand-text')
    }
  }, [])
  return null
}
